<template>
  <!--placeholder remove component-->
  <b-modal v-model="showPlaceholderRemoveModal" :width="400"  animation="zoom-out">
    <div class="model-card">

      <header class="modal-card-head">
        <p class="modal-card-title">Warning !</p>
        <button type="button" class="delete" @click="$emit('close-delete-modal')"></button>
      </header>

      <div class="modal-card-body">
        <div class="content pt-2">
          <div>
            Do you want to remove this template?
          </div>

          <div style="margin-top: 40px">
            <div class="columns">
              <div class="column">
                <b-button type="is-danger" rounded expanded outlined @click="removeTemplate($props.template_id)">Yes</b-button>
              </div>
              <div class="column">
                <b-button type="is-info" rounded expanded outlined @click="$emit('close-delete-modal')">No</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name:'delete-template',

  props:['template_id'],

  data(){
    return{
      showPlaceholderRemoveModal:true,
    }
  },

  methods:{
    removeTemplate:function (tempalteID){
        var component = this

        axios.post(component.$base_url+'/agent/deleteTemplate', {
          template_id: tempalteID,
          auth_token: component.$root.agentAuthToken
        })
            .then(function (response){
              var arr = [];
              arr = response.data
              if(arr.success == true){
                component.$buefy.toast.open({
                  message: 'Template has been successfully deleted',
                  type: 'is-success'
                })

               component.$emit('delete-success');

              }else{
                component.$buefy.toast.open({
                  message: 'Failed to delete template',
                  type: 'is-danger'
                })
              }

            })
            .catch(function (error) {
              console.log(error);
            });

      }
  }

}
</script>
